export const fundingSections = [
  {
    title: '배송 안내',
    description: [
      '버디에서 배송하는 상품입니다.',
      '펀딩 종료 후 제작이 시작되며, 제작 상황에 따라 배송 일정이 달라질 수 있습니다.',
      '예정 발송일은 판매 페이지에 표시된 날짜를 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 도서산간 지역의 경우 추가 배송비가 발생할 수 있으며, 금액은 주문/결제 페이지에서 확인 가능합니다.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
  {
    title: '교환 / 환불 안내',
    description: [
      '신청 방법: 주문 내역에서 신청하거나 고객센터로 문의해주세요.',
      '신청 기한: 배송완료일로부터 7일 이내',
      '교환 / 환불 비용: 상품 하자 등의 판매자 귀책 사유가 아닌 경우, 반품 배송비는 구매자가 부담합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불은 상품의 사용 흔적 또는 패키지 훼손 등으로 상품 가치가 훼손된 경우 제한될 수 있습니다.',
      '불량으로 인한 교환은 동일한 상품으로만 가능합니다.',
      '본 상품은 주문 제작 방식으로 판매되는 프리오더 펀딩 상품으로 판매 종료일 이후에는 제작이 시작되어 특정 상품의 경우 전자상거래법 제17조 제2항에 따라 주문 제작 상품은 청약 철회가 제한될 수 있습니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 상품과 다른 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const physicalCreatorGoodsNormal = [
  {
    title: '배송 안내',
    description: [
      '판매자가 직접 배송하는 상품입니다.',
      '굿즈 준비 기간 및 재고 상황에 따라 배송 시점이 달라질 수 있습니다.',
      '예정 배송일은 판매 페이지에 안내된 발송 시작일을 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 도서산간 지역의 경우 추가 배송비가 발생할 수 있으며, 금액은 주문/결제 페이지에서 확인 가능합니다.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
  {
    title: '교환 / 환불 안내',
    description: [
      '신청 방법: 주문 내역에서 신청하거나 고객센터로 문의해주세요.',
      '신청 기한: 배송완료일로부터 7일 이내',
      '교환 / 환불 비용: 상품 하자 등의 판매자 귀책 사유가 아닌 경우, 반품 배송비는 구매자가 부담합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불은 상품의 사용 흔적 또는 패키지 훼손 등으로 상품 가치가 훼손된 경우 제한될 수 있습니다.',
      '불량으로 인한 교환은 동일한 상품으로만 가능합니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 상품과 다른 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const physicalCreatorGoodsReserve = [
  {
    title: '배송 안내',
    description: [
      '판매자가 직접 배송하는 상품입니다.',
      '판매 종료 후 제작이 시작되며, 준비 기간에 따라 배송 일정이 달라질 수 있습니다.',
      '예정 배송일은 판매 페이지에 안내된 발송 시작일을 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 도서산간 지역의 경우 추가 배송비가 발생할 수 있으며, 금액은 주문/결제 페이지에서 확인 가능합니다.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
  {
    title: '교환 / 환불 안내',
    description: [
      '신청 방법: 주문 내역에서 신청하거나 고객센터로 문의해주세요.',
      '신청 기한: 배송완료일로부터 7일 이내',
      '교환 / 환불 비용: 상품 하자 등의 판매자 귀책 사유가 아닌 경우, 반품 배송비는 구매자가 부담합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불은 상품의 사용 흔적 또는 패키지 훼손 등으로 상품 가치가 훼손된 경우 제한될 수 있습니다.',
      '불량으로 인한 교환은 동일한 상품으로만 가능합니다.',
      '본 상품은 주문 제작 방식으로 판매되는 예약 판매 상품으로 판매 종료일 이후에는 제작이 시작되어 특정 상품의 경우 전자상거래법 제17조 제2항에 따라 주문 제작 상품은 청약 철회가 제한될 수 있습니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 상품과 다른 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const physicalVuddyOriginalNormal = [
  {
    title: '배송 안내',
    description: [
      '버디에서 배송하는 상품입니다.',
      '굿즈 준비 기간 및 재고 상황에 따라 배송 시점이 달라질 수 있습니다.',
      '예정 배송일은 판매 페이지에 안내된 발송 시작일을 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 도서산간 지역의 경우 추가 배송비가 발생할 수 있으며, 금액은 주문/결제 페이지에서 확인 가능합니다.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
  {
    title: '교환 / 환불 안내',
    description: [
      '신청 방법: 주문 내역에서 신청하거나 고객센터로 문의해주세요.',
      '신청 기한: 배송완료일로부터 7일 이내',
      '교환 / 환불 비용: 상품 하자 등의 판매자 귀책 사유가 아닌 경우, 반품 배송비는 구매자가 부담합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불은 상품의 사용 흔적 또는 패키지 훼손 등으로 상품 가치가 훼손된 경우 제한될 수 있습니다.',
      '불량으로 인한 교환은 동일한 상품으로만 가능합니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 상품과 다른 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const physicalVuddyOriginalReserve = [
  {
    title: '배송 안내',
    description: [
      '버디에서 배송하는 상품입니다.',
      '판매 종료 후 제작이 시작되며, 주문 제작 특성상 제작 기간에 따라 배송 일정이 달라질 수 있습니다.',
      '예정 발송일은 판매 페이지에 표시된 날짜를 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 도서산간 지역의 경우 추가 배송비가 발생할 수 있으며, 금액은 주문/결제 페이지에서 확인 가능합니다.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
  {
    title: '교환 / 환불 안내',
    description: [
      '신청 방법: 주문 내역에서 신청하거나 고객센터로 문의해주세요.',
      '신청 기한: 배송완료일로부터 7일 이내',
      '교환 / 환불 비용: 상품 하자 등의 판매자 귀책 사유가 아닌 경우, 반품 배송비는 구매자가 부담합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불은 상품의 사용 흔적 또는 패키지 훼손 등으로 상품 가치가 훼손된 경우 제한될 수 있습니다.',
      '불량으로 인한 교환은 동일한 상품으로만 가능합니다.',
      '본 상품은 주문 제작 방식으로 판매되는 예약 판매 상품으로 판매 종료일 이후에는 제작이 시작되어 특정 상품의 경우 전자상거래법 제17조 제2항에 따라 주문 제작 상품은 청약 철회가 제한될 수 있습니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 상품과 다른 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const digitalBasic = [
  {
    title: '지급 안내',
    description: [
      '해당 상품은 디지털 콘텐츠로, 구매 완료 후 [마이박스]에서 확인하실 수 있습니다.',
      '콘텐츠의 제공 형식 및 상세 내용은 판매 페이지에 명시된 정보를 기준으로 합니다.',
    ],
  },
  {
    title: '환불 안내',
    description: [
      '디지털 콘텐츠 특성상, 구매 완료 후에는 단순 변심에 의한 환불이 불가능합니다.',
      '콘텐츠에 기술적 문제가 있는 경우, 고객센터를 통해 확인 후 환불 여부가 결정될 수 있습니다.',
      '결과물에 대한 기대와의 차이 등 주관적인 사유로는 환불이 불가합니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '디지털 콘텐츠는 구매 계정에 귀속되며, 타인에게 양도 또는 재배포할 수 없습니다.',
      '저작권 보호를 위반하는 행위(무단 복제, 공유, 상업적 이용 등)는 법적 책임을 초래할 수 있습니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 구매한 콘텐츠와 다른 콘텐츠를 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

export const digitalCustom = [
  {
    title: '지급 안내',
    description: [
      '해당 상품은 구매자의 요청사항을 기반으로 제작되는 디지털 콘텐츠입니다.',
      '결제 완료 후, 판매자가 요청 정보를 확인한 뒤 제작을 시작하며, 완성된 콘텐츠는 [마이박스]에서 지급됩니다.',
      '콘텐츠의 제공 방식 및 예상 제작 기간은 판매 페이지에 안내된 내용을 기준으로 합니다.',
    ],
  },
  {
    title: '환불 안내',
    description: [
      '커스텀 디지털 콘텐츠는 주문 제작 방식으로, 결제 이후 단순 변심에 의한 환불이 불가능합니다.',
      '단, 커스텀 굿즈는 주문 제작 요청 후 24시간 이내에는 취소가 가능합니다.',
      '제작이 시작된 이후에는 환불이 제한됩니다.',
      '콘텐츠 자체에 기술적 문제가 있는 경우, 고객센터를 통해 확인 후 환불 여부가 결정됩니다.',
    ],
  },
  {
    title: '유의사항',
    description: [
      '제공된 커스텀 콘텐츠는 개인 이용 용도로만 사용할 수 있으며, 무단 공유 및 상업적 이용은 금지됩니다.',
      '저작권 보호를 위반하는 행위(무단 복제, 공유, 상업적 이용 등)는 법적 책임을 초래할 수 있습니다.',
      '버디 결제 시스템을 이용하지 않고 판매자와 직접 거래할 경우, 요청한 내용과 다른 콘텐츠를 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

// 2차 창작자 배송 정보 섹션
export const secondaryCreatorDeliveryInfo = [
  {
    title: '배송 안내',
    description: [
      '판매자가 직접 배송하는 상품입니다.',
      '굿즈 준비 기간 및 재고 상황에 따라 배송기간이 다소 지연될 수 있습니다.',
      '예약 판매 굿즈는 판매 페이지 내 표시된 배송 시작 예정일을 기준으로 순차 발송됩니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 국내 도서 산간 지역은 추가 배송비가 발생할 수 있습니다. 정확한 배송비는 주문/결제 화면에서 확인해주세요.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
];

// 2차 창작자 예약 판매 배송 정보 섹션
export const secondaryCreatorReservationDeliveryInfo = [
  {
    title: '배송 안내',
    description: [
      '판매자가 직접 배송하는 상품입니다.',
      '판매 종료 후 제작이 시작되며, 주문 제작 특성상 제작 기간에 따라 배송 일정이 달라질 수 있습니다.',
      '예정 배송일은 판매 페이지에 안내된 발송 시작일을 기준으로 합니다.',
      '배송 방법: 택배',
      '배송 지역: 전국',
      '배송 비용: 국내 도서 산간 지역은 추가 배송비가 발생할 수 있습니다. 정확한 배송비는 주문/결제 화면에서 확인해주세요.',
      '배송 기간: 발송 후 2~7일 소요',
    ],
  },
];

// 2차 창작자 교환/환불 정보 섹션
export const secondaryCreatorRefundInfo = [
  {
    title: '교환 / 환불',
    description: [
      '교환 · 환불 신청: 주문 내역에서 신청 혹은 고객센터 문의해주세요.',
      '교환 · 환불 가능 기간: 배송완료일로부터 7일 이내에 신청해야 합니다.',
      '교환 · 환불 비용: 구매자의 변심으로 환불할 경우 구매자 부담이며, 상품 하자 등의 판매자 사유일 경우 판매자가 부담합니다.',
    ],
  },
  {
    title: '교환 / 환불 유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불의 경우 상품의 사용 흔적이 있거나, 라벨 제거 등으로 상품 가치가 훼손된 경우 불가합니다.',
      '교환은 불량일 경우 동일한 상품으로 가능합니다.',
      '버디의 결제 시스템을 이용하지 않고 판매자와 직접 거래한 경우 상품을 받지 못하거나, 구매한 상품과 상이한 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];

// 2차 창작자 예약 판매 교환/환불 정보 섹션
export const secondaryCreatorReservationRefundInfo = [
  {
    title: '교환 / 환불',
    description: [
      '교환 · 환불 신청: 주문 내역에서 신청 혹은 고객센터 문의해주세요.',
      '교환 · 환불 가능 기간: 배송완료일로부터 7일 이내에 신청해야 합니다.',
      '교환 · 환불 비용: 구매자의 변심으로 환불할 경우 구매자 부담이며, 상품 하자 등의 판매자 사유일 경우 판매자가 부담합니다.',
    ],
  },
  {
    title: '교환 / 환불 유의사항',
    description: [
      '단순 변심으로 인한 교환은 불가합니다.',
      '단순 변심으로 인한 환불의 경우 상품의 사용 흔적이 있거나, 라벨 제거 등으로 상품 가치가 훼손된 경우 불가합니다.',
      '교환은 불량일 경우 동일한 상품으로 가능합니다.',
      '본 상품은 주문 제작 방식으로 판매되는 예약 판매 상품으로 판매 종료일 이후에는 제작이 시작되어 특정 상품의 경우 전자상거래법 제17조 제2항에 따라 주문 제작 상품은 청약 철회가 제한될 수 있습니다.',
      '버디의 결제 시스템을 이용하지 않고 판매자와 직접 거래한 경우 상품을 받지 못하거나, 구매한 상품과 상이한 상품을 받는 등의 피해가 발생할 수 있습니다.',
    ],
  },
];
